import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _createForOfIteratorHelper from '@babel/runtime/helpers/esm/createForOfIteratorHelper';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { presetDecorator, RemirrorManager, getLazyArray, Preset } from '@remirror/core';
import { DocExtension } from '@remirror/extension-doc';
import { EventsExtension } from '@remirror/extension-events';
import { GapCursorExtension } from '@remirror/extension-gap-cursor';
import { HistoryExtension } from '@remirror/extension-history';
import { ParagraphExtension } from '@remirror/extension-paragraph';
import { PositionerExtension } from '@remirror/extension-positioner';
import { TextExtension } from '@remirror/extension-text';

var _dec, _class, _temp;
/**
 * The options for the core preset.
 */

var CorePreset = (_dec = /*#__PURE__*/presetDecorator({
  defaultOptions: /*#__PURE__*/_objectSpread( /*#__PURE__*/_objectSpread( /*#__PURE__*/_objectSpread( /*#__PURE__*/_objectSpread({}, DocExtension.defaultOptions), ParagraphExtension.defaultOptions), HistoryExtension.defaultOptions), {}, {
    excludeExtensions: []
  }),
  customHandlerKeys: ['positioner'],
  handlerKeys: ['onRedo', 'onUndo'],
  staticKeys: ['content', 'depth', 'newGroupDelay', 'excludeExtensions']
}), /*#__PURE__*/_dec(_class = (_temp = class CorePreset extends Preset {
  constructor() {
    super(...arguments);

    _defineProperty(this, "onAddCustomHandler", handlers => {
      var positioner = handlers.positioner;

      if (positioner) {
        return this.getExtension(PositionerExtension).addCustomHandler('positioner', positioner);
      }

      return;
    });
  }

  get name() {
    return 'core';
  }
  /**
   * No properties are defined so this can be ignored.
   */


  onSetOptions(_) {}

  createExtensions() {
    var _this$options = this.options,
        content = _this$options.content,
        depth = _this$options.depth,
        getDispatch = _this$options.getDispatch,
        getState = _this$options.getState,
        newGroupDelay = _this$options.newGroupDelay,
        excludeExtensions = _this$options.excludeExtensions;
    var excludeMap = {};

    var _iterator = _createForOfIteratorHelper(excludeExtensions !== null && excludeExtensions !== void 0 ? excludeExtensions : []),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var name = _step.value;
        excludeMap[name] = true;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var coreExtensions = [];

    if (!excludeMap['history']) {
      var historyExtension = new HistoryExtension({
        depth,
        getDispatch,
        getState,
        newGroupDelay
      });
      historyExtension.addHandler('onRedo', this.options.onRedo);
      historyExtension.addHandler('onUndo', this.options.onUndo);
      coreExtensions.push(historyExtension);
    }

    if (!excludeMap['doc']) {
      coreExtensions.push(new DocExtension({
        content
      }));
    }

    if (!excludeMap['text']) {
      coreExtensions.push(new TextExtension());
    }

    if (!excludeMap['paragraph']) {
      coreExtensions.push(new ParagraphExtension());
    }

    if (!excludeMap['positioner']) {
      coreExtensions.push(new PositionerExtension());
    }

    if (!excludeMap['gapCursor']) {
      coreExtensions.push(new GapCursorExtension());
    }

    if (!excludeMap['events']) {
      coreExtensions.push(new EventsExtension());
    }

    return coreExtensions;
  }

}, _temp)) || _class);

/**
 * Create a manager with the core preset already applied.
 */
function createCoreManager(combined) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var core = options.core,
      managerSettings = _objectWithoutProperties(options, ["core"]);

  return RemirrorManager.create(() => [...getLazyArray(combined), new CorePreset(core)], managerSettings);
}

export { CorePreset, createCoreManager };
